export default {
  classTrans: '수업 이동',
  classTransDiff: '가격이 다른 수업 이동',
  actuallyPrice: '수강료 (대상 수업)',
  remainingFee: '잔여 수강료 (현재 수업)',
  refundTotal: '환불 총액',
}
